module.exports = __webpack_public_path__ + "media/images/logo_full-64f9375d0fa2b81eb75615e8fc319aeb.svg";